import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vb_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const AFFILIATE = {
  booking: `${API_BASE}/go/booking`,
  bookingLuxury: `${API_BASE}/go/booking-luxury`,
  bookingFamily: `${API_BASE}/go/booking-family`,
  bookingBudget: `${API_BASE}/go/booking-budget`,
  expedia: `${API_BASE}/go/expedia`,
  getYourGuide: `${API_BASE}/go/getyourguide`,
  getYourGuideActivities: `${API_BASE}/go/getyourguide-activities`,
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_7ae9931d-e78b-4d32-998f-5035d31993a9/artifacts/c072ia1g_ChatGPT%20Image%20Apr%2018%2C%202026%2C%2009_21_06%20AM.png";

export const IMG = {
  heroEmbankment:
    "https://customer-assets.emergentagent.com/job_explore-bedford-now/artifacts/6i89iwkm_image.png",
  familyThemePark:
    "https://static.prod-images.emergentagent.com/jobs/7ae9931d-e78b-4d32-998f-5035d31993a9/images/4e8c613a62ba577e348a7df2a9a94b70c2fd8eb75c9c0945c58f2e281999d63b.png",
  trainTravel:
    "https://static.prod-images.emergentagent.com/jobs/7ae9931d-e78b-4d32-998f-5035d31993a9/images/9e805a650d6d2f4c337f7fe1cc0bcab10729cb0908e11065595261db1313b030.png",
  riverPark:
    "https://images.unsplash.com/photo-1680205159774-703dd37b8fee?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  riverHouses:
    "https://images.unsplash.com/photo-1504363014482-e47ef8dfa815?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  luxuryHotel1:
    "https://images.unsplash.com/photo-1759264244746-140bbbc54e1b?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  luxuryHotel2:
    "https://images.unsplash.com/photo-1567552379232-c32f3d41d353?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  afternoonTea1:
    "https://images.unsplash.com/photo-1581934469832-1c14854646bf?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  afternoonTea2:
    "https://images.unsplash.com/photo-1579372785655-a81b19e99b8b?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  familyRoom:
    "https://images.unsplash.com/photo-1590490360182-c33d57733427?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  budgetHotel:
    "https://images.unsplash.com/photo-1566665797739-1674de7a421a?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  pubFood:
    "https://images.unsplash.com/photo-1555992336-03a23c7b20ee?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  countryside:
    "https://images.unsplash.com/photo-1500534623283-312aade485b7?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  cambridge:
    "https://images.unsplash.com/photo-1559089174-b1ef1b7b5713?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  londonTube:
    "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  marketSquare:
    "https://images.unsplash.com/photo-1519677100203-a0e668c92439?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
};
